import * as i0 from '@angular/core';
import { InjectionToken, NgModule, Injectable, Optional, Inject, Directive, Input } from '@angular/core';
import { fusion } from '@js-dot/core';
const DOT_PAGINATION_MODULE_CONFIGURE = new InjectionToken('#ng-dot/ui/pagination/configure');
class DotPaginationModule {
  static forRoot(configure) {
    return {
      ngModule: DotPaginationModule,
      providers: [{
        provide: DOT_PAGINATION_MODULE_CONFIGURE,
        useValue: configure
      }]
    };
  }
  static ɵfac = function DotPaginationModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotPaginationModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DotPaginationModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotPaginationModule, [{
    type: NgModule,
    args: [{}]
  }], null, null);
})();
class DotPaginateService {
  configure;
  constructor(configure) {
    this.configure = fusion({
      icons: {}
    }, configure);
  }
  static ɵfac = function DotPaginateService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotPaginateService)(i0.ɵɵinject(DOT_PAGINATION_MODULE_CONFIGURE, 8));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DotPaginateService,
    factory: DotPaginateService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotPaginateService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [DOT_PAGINATION_MODULE_CONFIGURE]
    }]
  }], null);
})();
class DotPaginateComponentBase {
  _pagination;
  total;
  page = 1;
  limit = 24;
  set meta(value) {
    this.total = value['total'];
    this.limit = value['limit'];
    this.page = value['page'];
    this._paginateUpdate();
  }
  get paginateIcons() {
    return this._pagination.configure.icons;
  }
  constructor(_pagination) {
    this._pagination = _pagination;
  }
  ngOnInit() {
    this._paginateUpdate();
  }
  static ɵfac = function DotPaginateComponentBase_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotPaginateComponentBase)(i0.ɵɵdirectiveInject(DotPaginateService));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DotPaginateComponentBase,
    inputs: {
      total: "total",
      page: "page",
      limit: "limit",
      meta: "meta"
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotPaginateComponentBase, [{
    type: Directive
  }], () => [{
    type: DotPaginateService
  }], {
    total: [{
      type: Input
    }],
    page: [{
      type: Input
    }],
    limit: [{
      type: Input
    }],
    meta: [{
      type: Input
    }]
  });
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DOT_PAGINATION_MODULE_CONFIGURE, DotPaginateComponentBase, DotPaginateService, DotPaginationModule };
